/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmDocumentQueryStatus extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSsmDocumentQueryStatus");
    }

    getFixupPrototypeFunction() { return AwsSsmDocumentQueryStatus.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmDocumentQueryStatus>): AwsSsmDocumentQueryStatus {
        let obj = Object.assign(new AwsSsmDocumentQueryStatus(), model);
        AwsSsmDocumentQueryStatus.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmDocumentQueryStatus>): AwsSsmDocumentQueryStatus {
        if (!model) return null;
        return AwsSsmDocumentQueryStatus.newInstance(<AwsSsmDocumentQueryStatus> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmDocumentQueryStatus) {
        if (!obj) return;

        models.AwsSsmDocumentQueryStatus.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmDocumentQueryStatus): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSsmDocumentQueryStatus.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * List of status of the execution
     */
    statuses: Array<string>;

}
